/*
saikrishna 11/04/2022  2700430604 Added Stepper
Sohel 11/08/2022 2700430604 Integrated Save API
Sohel 11/08/2022 2700430604 Passing Props
Sohel 11/08/2022 2700430604 removed extra button
Sohel 11/09/2022 2700430604 Added Field List Code
Prakash Gummala 11/10/2022 2700430604 Added Card for stepper screen.
Ravi 11/21/2022 2700430604 Added stepper tabs  toast messages
lalitha 11/23/2022 2700430604 added completed styles in stepper
akhila 11/24/2022 2700430604 implemented animations to completed step
Ashraf 11/24/2022 2700430604 renamed last step action to actions
akhila 11/24/2022 2700430604 changed background color for selected step
saikrishna 11/25/2022 2700430604 Added SaveAlert
akhila 11/26/2022 2700430604 passed overrideType in payload
Suresh Peddavoora 11/28/2022 2700430604 Modified Styles for Stepper Icon
Sai Maheshwar 12/03/2022 2701135832 added AND/OR conditions
Sai maheshwar 12/04/2022 2700430604 added unsaved changes alert
Lalitha 12/08/2022 2700430604 Rename Filter to Add Filter
Poornima 12/08/2022 2700430604 Added download configuration button
Lalitha 12/09/2022  2700430604 Added reusable backButtonText
Saikrishna 12/09/2022 2700430604 save and stay in page functionality added.
Sohel 12/16/2022 2700430604 removed field List step
Ashraf 12/20/2022 2700430604 fixed user role access
Prakash 12/21/2022 2700753823 Adjusted Padding Alignment.
Ashraf 12/21/2022 2700430604 fixed steps initial value
Prakash 12/26/2022 2700430604 Removed Card Component and added card styling.
Suresh peddavoora 12/26/2022 2700430604 Fixed stepper Icon alignments
Akhila 01/20/2023 2700430604 unsaved chnages alert popup issue fixed
Akhila 02/08/2023 2700430604 printIndividual added in payload
Raghu 02/22/2023 2700430604 changed stepper color
Dilip 02/22/2023 2700430604 added download usage configuration
Akhila 02/17/2023 2700430604 preview file implemented in download configuration
Dilip 02/22/2023 2700430604 changed download usage configuration payload
Akhila 02/28/2023 2700430604 Added loader and download toast message in preview FIle
Sohel 03/10/2023 2700430604 added StepIconComponent for showing Numbers in StepLabel
Sohel 03/13/2023 2700430604 Added Last Step in payload
Sohel 03/14/2023 2700430604 Added Last Step changes
Sohel 03/16/2023 2700430604 Fixed Stepper Step Issue
Ravi 06/09/2023 2700430604 Added Breadcrums in preview
*/
import {Button, makeStyles, Stepper, StepLabel, Step} from '@material-ui/core';
import {ArrowBack} from '@material-ui/icons';
import React, {useContext, useEffect, useRef, useState} from 'react';
import reusableInputStyles from '../../../../components/InputStyles';
import BasicInfo from './BasicInfo';
import FilterRule from './FilterRule';
import TriggerActions from './TriggerActions';
import {useDispatch, useSelector} from 'react-redux';
import StepConnector from '@material-ui/core/StepConnector';
import {withStyles} from '@material-ui/core/styles';
import SelectTabContextProvider from '../../../../components/SelectTabContext/SelectTabContext';
import useUnsavedChangesWarning from '../../../../util/CustomHooks';
import {setAlertData} from '../../../../redux/reducers/UnsavedChangesAlertReducer';
import {
  printEventTactics,
  resetConfigUrl,
} from '../../../../redux/reducers/EventTactics/EventTactics';
import {backButtonText} from '../../../../util/Content';
import {postPrintUsage} from '../../../../redux/reducers/printUsage';
import {downloadButton} from '../../../../util/Content';
import axios from 'axios';
import PreviewFileDialog from '../../../../util/PreviewFileDialog';
import PageLoader from '../../../../components/PageLoader';
import {resetDownloadMsg} from '../../../../redux/reducers/PreviewFileData';
import NumberStepIcon from '../../../../components/customStepIcon';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  backButton: {
    marginRight: theme.spacing(1),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  stepperIcon: {
    '& .MuiStepLabel-iconContainer': {
      '& .MuiStepIcon-root': {
        width: '35px !important',
        height: '35px !important',
      },
    },
    '& .MuiStepIcon-completed': {
      color: '#056c93',
    },
    '& .MuiStepIcon-active': {
      color: '#056c93',
    },
    '& .MuiStepLabel-labelContainer': {
      '& .MuiTypography-root': {
        fontSize: '1rem',
        fontWeight: 600,
        fontFamily: 'articulat-cf, sans-serif !important',
      },
    },
  },
}));
const QontoConnector = withStyles({
  alternativeLabel: {
    top: 10,
    left: 'calc(-50% + 16px)',
    right: 'calc(50% + 16px)',
  },
  active: {
    '& $line': {
      borderColor: '#056c93',
    },
  },
  completed: {
    '& $line': {
      borderColor: '#056c93',
    },
  },
  line: {
    borderColor: '#eaeaf0',
    borderTopWidth: 3,
    borderRadius: 1,
  },
})(StepConnector);
const AddEventTactic = ({setValue, handleTabChange, setTabValue, rowSelected}) => {
  const {eventTacticData, configurationUrl , dockey} = useSelector(({addEventTactic}) => addEventTactic);
  const stepperClasses = useStyles();
  const dispatch = useDispatch();
  const classes = reusableInputStyles();
  const steps = ['Basic Info', 'Add Filter', 'Actions'];
  const [activeStep, setActiveStep] = React.useState(0);
  const [stepSuccessMsg, setStepSuccessMsg] = React.useState('');
  const showAlertRef = useRef(false);
  const {onDirty, onPristine} = useUnsavedChangesWarning();

  const {setSaveTab, saveTab, setSample} =
    useContext(SelectTabContextProvider);
  // const [overrideType, setOverrideType] = useState(true);
  const overrideType = true;
  const handleNext = (value) => {
    setActiveStep((prevActiveStep) => (value ? Number(value) + 1 : prevActiveStep + 1));
  };

  const [loading, setIsLoadingDelete] = useState(false);
  const [configOpen, setConfigOpen] = useState(false);
  const [configData, setConfigData] = useState(null);

  const handleConfigClose = () => {
    setConfigOpen(false);
    dispatch(resetConfigUrl());
    dispatch(resetDownloadMsg());
  };
  const saveRef = useRef();
  useEffect(() => {
    if (configurationUrl) {
      setIsLoadingDelete(true);
      async function readData() {
        setConfigOpen(true);
        const data = await axios({
          url: configurationUrl,
          method: 'GET',
        });
        setConfigData(data);
        setIsLoadingDelete(false);
      }
      readData();
    }
  }, [configurationUrl]);
  const changeDirty = useRef(true);
  const handleDirty = (dirty, isFixed) => {
    if (isFixed === 'fixed') {
      showAlertRef.current = dirty;
      changeDirty.current = false;
      if (dirty) {
        onDirty();
      } else {
        onPristine();
      }
    }
    if (isFixed === 'reset') {
      showAlertRef.current = false;
      changeDirty.current = true;
      onPristine();
    }
    if (changeDirty.current) {
      showAlertRef.current = dirty;
      if (dirty) {
        onDirty();
      } else {
        onPristine();
      }
    }
  };
  const alertProps = {
    showAlertRef,
    handleDirty,
  };
  const handleBack = () => {
    if (showAlertRef.current) {
      dispatch(
        setAlertData({
          showAlert: showAlertRef.current,
          alertCallback: () => {
            setActiveStep((prevActiveStep) => prevActiveStep - 1);
          },
        }),
      );
    } else {
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
    }
  };
  useEffect(() => {
    if (eventTacticData?.code) {
      if (eventTacticData?.isDraft === 'N') {
        setActiveStep(0);
      } else if(!saveRef.current)  {
        setActiveStep(Number(eventTacticData?.lastStep));
      }
    }
  }, [eventTacticData?.code]);
  const getStepContent = (stepIndex) => {
    switch (stepIndex) {
    case 0:
      return (
        <BasicInfo
          handleTabChange={handleTabChange}
          handleBack={handleBack}
          activeStep={activeStep}
          handleNext={handleNext}
          steps={steps}
          stepSuccessMsg={stepSuccessMsg}
          setStepSuccessMsg={setStepSuccessMsg}
          setSample={setSample}
          setSaveTab={setSaveTab}
          saveTab={saveTab}
          rowSelected={rowSelected}
          saveRef={saveRef}
          {...alertProps}
        />
      );
      // case 1:
      //   return (
      //     <FieldList
      //       handleBack={handleBack}
      //       handleNext={handleNext}
      //       fieldListCode={fieldListCode}
      //       setFieldListCode={setFieldListCode}
      //       fieldList={fieldList}
      //       setFieldList={setFieldList}
      //       steps={steps}
      //       stepSuccessMsg={stepSuccessMsg}
      //       setStepSuccessMsg={setStepSuccessMsg}
      //       activeStep={activeStep}
      //       {...alertProps}
      //     />
      //   );
    case 1:
      return (
        <FilterRule
          handleBack={handleBack}
          handleNext={handleNext}
          // fieldListCode={fieldListCode}
          steps={steps}
          stepSuccessMsg={stepSuccessMsg}
          setStepSuccessMsg={setStepSuccessMsg}
          activeStep={activeStep}
          overrideType={overrideType}
          rowSelected={rowSelected}
          {...alertProps}
        />
      );
    case 2:
      return (
        <TriggerActions
          handleBack={handleBack}
          setValue={setValue}
          steps={steps}
          stepSuccessMsg={stepSuccessMsg}
          setStepSuccessMsg={setStepSuccessMsg}
          activeStep={activeStep}
          rowSelected={rowSelected}
          {...alertProps}
        />
      );
    }
  };
  const isCurrentStepperCompleted = eventTacticData?.isDraft === 'N';
  const stepProps = {};
  if (isCurrentStepperCompleted) {
    stepProps.nonLinear = true;
  } else {
    stepProps.nonLinear = false;
  }
  return (
    <>
      <PreviewFileDialog
        open={configOpen}
        dialogClose={handleConfigClose}
        fileUrl={configurationUrl}
        configData={configData}
        dockey={dockey}
        moduleName={'Trigger Maintenance'}
        name={'Trigger Name'}
        code={eventTacticData?.code}
        description={'Trigger Description'}
        descriptionValue={eventTacticData?.description}
      />
      <div className={`${classes.cardStyleWhite}`}>
        <div className="button-table-spacing-mb justify-content-between new-standard-textfields">
          <Button
            variant="outlined"
            type="button"
            className={`search-btn mx-1 ${classes.buttonRoot}`}
            onClick={() => {
              if (showAlertRef.current) {
                dispatch(
                  setAlertData({
                    showAlert: showAlertRef.current,
                    alertCallback: () => {
                      setValue(0);
                    },
                  }),
                );
              } else {
                setValue(0);
              }
              // if (sample) {
              //   handleTabChange("e", 0);
              // } else {
              //   setValue(0);
              // }
            }}
          >
            <ArrowBack className="mr-2" />
            {backButtonText}
          </Button>
          {eventTacticData?.code && (
            <div>
              <Button
                type="button"
                variant="outlined"
                className={`mx-1 search-btn`}
                // disabled={Boolean(countTotal === 0)}
                onClick={(event) => {
                  dispatch(
                    postPrintUsage({
                      baseCategory: '',
                      code: eventTacticData?.code ? eventTacticData.code : '',
                      description: eventTacticData?.description ? eventTacticData?.description : '',
                      displayName: '',
                      fileType: '',
                      recordFormatType: '',
                      returnType: '',
                      sourceType: 'TRIGGER MAINTENANCE',
                      isDraft: eventTacticData?.isDraft?.key ? eventTacticData?.isDraft?.key : '',
                      search: '',
                      frameworkUsageOrderBy: '',
                      frameworkUsageOrderDerection: '',
                      fieldListOrderBy: '',
                      fieldListOrderDerection: '',
                      category: '',
                      fieldName: '',
                      repositoryDescription: '',
                      repositoryName: '',
                      repositoryType: '',
                      createdBy: '',
                      createdDate: '',
                    }),
                  );
                }}
              >
                Download Configuration Usage
              </Button>
              <Button
                type="button"
                variant="outlined"
                className={`mx-1 search-btn`}
                color="primary"
                // disabled={!countTotal}
                onClick={(event) => {
                  dispatch(
                    printEventTactics({
                      eventTacticCode: eventTacticData?.code ? eventTacticData.code : '',
                      eventTacticDescription: eventTacticData?.description ?
                        eventTacticData?.description :
                        '',
                      eventType: '',
                      eventTacticMode: eventTacticData?.mode ? eventTacticData?.mode : '',
                      isDraft: eventTacticData?.isDraft?.key ? eventTacticData?.isDraft?.key : '',
                      search: '',
                      orderBy: '',
                      orderDirection: '',
                      printIndividual: 'Y',
                    }),
                  );
                }}
              >
                {downloadButton}
              </Button>
            </div>
          )}
        </div>
        <div className={classes.root} style={{border: '1px solid #cfcfcf'}}>
          <Stepper {...stepProps} activeStep={activeStep} connector={<QontoConnector />}>
            {steps.map((label, index) => (
              <Step
                key={label}
                completed={
                  isCurrentStepperCompleted ||
                  index < activeStep ||
                  index < Number(eventTacticData?.lastStep)
                }
                onClick={() => {
                  if (
                    eventTacticData?.isDraft === 'N' ||
                    index < activeStep ||
                    index < Number(eventTacticData?.lastStep)
                  ) {
                    if (showAlertRef.current) {
                      dispatch(
                        setAlertData({
                          showAlert: showAlertRef.current,
                          alertCallback: () => {
                            setActiveStep(index);
                          },
                        }),
                      );
                    } else {
                      setActiveStep(index);
                    }
                  } else if (index < activeStep) {
                    setActiveStep(index);
                  }
                }}
                style={{cursor: 'pointer'}}
              >
                <StepLabel
                  className={`${stepperClasses.stepperIcon} ${
                    activeStep === index ? 'completedStyle' : null
                  }`}
                  StepIconComponent={NumberStepIcon}
                >
                  {label}
                </StepLabel>
              </Step>
            ))}
          </Stepper>
          <div>
            <div style={{padding: '1rem 0.5rem'}}>{getStepContent(activeStep)}</div>
          </div>
        </div>
      </div>
      {loading && <PageLoader />}
    </>
  );
};

export default AddEventTactic;
